import { render, staticRenderFns } from "./order_timeline_status.vue?vue&type=template&id=5c08e9f7&scoped=true&"
import script from "./order_timeline_status.vue?vue&type=script&lang=js&"
export * from "./order_timeline_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c08e9f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c08e9f7')) {
      api.createRecord('5c08e9f7', component.options)
    } else {
      api.reload('5c08e9f7', component.options)
    }
    module.hot.accept("./order_timeline_status.vue?vue&type=template&id=5c08e9f7&scoped=true&", function () {
      api.rerender('5c08e9f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/order_timeline_status.vue"
export default component.exports